module.exports = __webpack_public_path__ + "img/shelter-national-gap.f1779ab9.png";